import React, { useState } from "react";
import "./certifications.css";

const certificationsData = [
  {
    name: "Responsive Web Designs",
    title: "Responsive Web Design Certification",
    from: "FreeCodeCamp.org",
    des: "Mastered the principles of responsive web design, including flexible layouts, media queries, and mobile-first development. Built accessible, user-friendly websites that adapt seamlessly across devices, using HTML5 and CSS3 best practices.",
    link: "https://freecodecamp.org/certification/saddamAnwar/responsive-web-design",
  },
  {
    name: "Frontend Libraries",
    title: "Frontend Development Libraries Certification",
    from: "freeCodeCamp",
    des: "Built dynamic, responsive web applications using modern tools like React for component-based architecture, Redux for state management, Next.js for server-side rendering and routing, and Tailwind CSS for utility-first styling. Gained hands-on experience in building scalable, production-ready frontend interfaces.",
    link: "https://freecodecamp.org/certification/saddamAnwar/front-end-development-libraries",
  },
];

const Certifications = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion-container">
      <h1 className="title">My Certifications</h1>
      {certificationsData.map((cert, index) => (
        <div
          key={index}
          className={`accordion-item ${activeIndex === index ? "active" : ""}`}
        >
          <button className="accordion-header" onClick={() => toggle(index)}>
            <div>
              <h2>{cert.name}</h2>
              <span className="from">From: {cert.from}</span>
            </div>
            <span className="icon">{activeIndex === index ? "-" : "+"}</span>
          </button>
          <div className="accordion-body">
            <h3>{cert.title}</h3>
            <p>{cert.des}</p>
            <a href={cert.link} target="_blank" rel="noopener noreferrer">
              View Certificate
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Certifications;
